// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__W9NsE","header":"ReportDetails_header__1tjCh","title":"ReportDetails_title__2JyCE","left":"ReportDetails_left__1e-Mn"};